/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_MenuInputs */

const bn_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মেনু`)
};

const de_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte`)
};

const el_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μενού`)
};

const en_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const es_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú`)
};

const fr_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const hi_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेनू`)
};

const hu_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü`)
};

const id_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const it_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const ja_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メニュー`)
};

const ko_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메뉴`)
};

const nl_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const pl_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const pt_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const ru_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню`)
};

const sv_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meny`)
};

const tr_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü`)
};

const uk_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню`)
};

const vi_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thực đơn`)
};

const zh_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`菜单`)
};

const zh_hant_action_menu = /** @type {(inputs: Action_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選單`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Action_MenuInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_menu = /** @type {((inputs?: Action_MenuInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_MenuInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_menu(inputs)
	if (locale === "de") return de_action_menu(inputs)
	if (locale === "el") return el_action_menu(inputs)
	if (locale === "en") return en_action_menu(inputs)
	if (locale === "es") return es_action_menu(inputs)
	if (locale === "fr") return fr_action_menu(inputs)
	if (locale === "hi") return hi_action_menu(inputs)
	if (locale === "hu") return hu_action_menu(inputs)
	if (locale === "id") return id_action_menu(inputs)
	if (locale === "it") return it_action_menu(inputs)
	if (locale === "ja") return ja_action_menu(inputs)
	if (locale === "ko") return ko_action_menu(inputs)
	if (locale === "nl") return nl_action_menu(inputs)
	if (locale === "pl") return pl_action_menu(inputs)
	if (locale === "pt") return pt_action_menu(inputs)
	if (locale === "ru") return ru_action_menu(inputs)
	if (locale === "sv") return sv_action_menu(inputs)
	if (locale === "tr") return tr_action_menu(inputs)
	if (locale === "uk") return uk_action_menu(inputs)
	if (locale === "vi") return vi_action_menu(inputs)
	if (locale === "zh") return zh_action_menu(inputs)
	return zh_hant_action_menu(inputs)
});